import React from 'react';
import { PeerReviewQuery } from './queries';
import { SpinnerOverlay } from 'spinner';
// eslint-disable-next-line import/no-extraneous-dependencies
import { jsonStringify } from '@datadog/browser-core';
import { sortBy, last, isEmpty } from 'lodash';
import { HistoryReview } from '../review-tool/HistoryReview';
import { useQuery } from '@apollo/client';

type PeerReviewStatusProps = {
  clientId: string;
};

export const PeerReviewStatus = ({ clientId }: PeerReviewStatusProps) => {
  const { loading, error, data } = useQuery(PeerReviewQuery, { variables: { clientId } });

  if (loading) {
    return <SpinnerOverlay />;
  }

  if (error) {
    return <div> Error: {jsonStringify(error)}</div>;
  }

  if (isEmpty(data.reviewHistoryPeriod)) {
    return <p>This client does not have any reviews yet.</p>;
  }

  const latestReviewPeriod = last(sortBy(data.reviewHistoryPeriod, ['submittedAt']));
  const { notes, status, hideDate, submitterId, submittedAt, fromMonth, toMonth } =
    latestReviewPeriod;
  return (
    <HistoryReview
      fromDate={fromMonth}
      toDate={toMonth}
      notes={notes}
      status={status}
      hideDate={hideDate}
      submitterId={submitterId}
      submittedAt={submittedAt}
    />
  );
};

export default PeerReviewStatus;
